import React from 'react';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import { servicesPageData } from '../data/mockData';

const ServicesPage = () => {
  return (
    <PageLayout scriptLabel={servicesPageData.scriptLabel} heading={servicesPageData.heading}>
      {/* Intro Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <p className="font-open-sans text-[#666] text-lg leading-relaxed mb-10">
            {servicesPageData.intro}
          </p>

          {/* Call to Action */}
          <div className="bg-[#F3ECF8] rounded-sm p-8 md:p-12 mb-16">
            <p className="font-seaweed text-[#C9A84C] text-3xl mb-2">Call us today</p>
            <a
              href="tel:7196842180"
              className="text-[#4A154B] text-4xl md:text-5xl font-playfair font-bold hover:text-[#C9A84C] transition-colors duration-300 block mb-3"
            >
              {servicesPageData.phone}
            </a>
            <p className="font-open-sans text-[#666] text-base">
              {servicesPageData.phoneSubtext}
            </p>
          </div>
        </div>
      </section>

      {/* Packages Section */}
      {servicesPageData.packages.map((pkg, i) => (
        <section key={i} className="py-16 px-4 bg-[#F3ECF8]">
          <div className="max-w-4xl mx-auto">
            <p className="font-seaweed text-[#C9A84C] text-3xl mb-1 text-center">
              {pkg.category}
            </p>
            <h2 className="font-playfair text-[#1a1a1a] text-3xl md:text-4xl font-bold mb-8 text-center">
              {pkg.title}
            </h2>

            <p className="font-open-sans text-[#666] text-base leading-relaxed text-center mb-4">
              {pkg.description}
            </p>

            {pkg.virtualNote && (
              <p className="font-open-sans text-[#C9A84C] text-sm tracking-[0.15em] uppercase text-center mb-10 font-bold">
                {pkg.virtualNote}
              </p>
            )}

            <div className="grid gap-6 max-w-lg mx-auto">
              {pkg.options.map((option, j) => (
                <div
                  key={j}
                  className="bg-white rounded-sm p-8 text-center shadow-sm hover:shadow-lg transition-shadow duration-300"
                >
                  <h3 className="font-open-sans text-[#1a1a1a] text-sm tracking-[0.15em] font-bold uppercase mb-4">
                    {option.name}
                  </h3>
                  <div className="w-16 h-px bg-[#C9A84C] mx-auto mb-4" />
                  <p className="font-playfair text-[#C9A84C] text-5xl font-bold mb-6">
                    {option.price}
                  </p>
                  <Link
                    to="/healing-techniques"
                    className="inline-flex items-center gap-3 text-[#C9A84C] font-open-sans text-xs tracking-[0.2em] uppercase hover:text-[#B89740] transition-colors duration-300"
                  >
                    LEARN MORE ABOUT ENERGY WORK
                    <span className="text-lg">—</span>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* Additional CTA */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <p className="font-seaweed text-[#C9A84C] text-3xl mb-4">Ready to feel your best?</p>
          <div className="flex items-center justify-center gap-3 mb-6">
            <Phone size={24} className="text-[#C9A84C]" />
            <a
              href="tel:7196842180"
              className="text-[#4A154B] text-2xl font-playfair font-bold hover:text-[#C9A84C] transition-colors duration-300"
            >
              {servicesPageData.phone}
            </a>
          </div>
          <Link
            to="/contact"
            className="inline-block px-8 py-3 bg-[#C9A84C] text-white font-open-sans text-xs tracking-[0.2em] uppercase hover:bg-[#B89740] transition-colors duration-300"
          >
            CONTACT US
          </Link>
        </div>
      </section>
    </PageLayout>
  );
};

export default ServicesPage;
